

// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/free-mode';

// import { FreeMode, Pagination } from 'swiper/modules';
// import { RxArrowTopRight } from 'react-icons/rx';
// import { ServiceData } from '../constants';

// const Work = () => {
//     return (
//         <div>
//             <div className='items-center text-center mt-20'>
//                 <h1 className="font-extrabold text-2xl md:text-3xl text-purple-800 mb-2">
//                     Our Work
//                 </h1>
//                 <p className='font-bold text-lg md:text-xl text-blue-800 mb-4'>
//                     We provide high standard work for your Company solutions
//                 </p>
//             </div>

//             <div className="flex items-center justify-center flex-col  my-10">
//                 <Swiper
//                     breakpoints={{
//                         340: {
//                             slidesPerView: 2,
//                             spaceBetween: 15,
//                         },
//                         700: {
//                             slidesPerView: 3,
//                             spaceBetween: 15,
//                         },
//                     }}
//                     freeMode={true}
//                     pagination={{
//                         clickable: true,
//                     }}
//                     modules={[FreeMode, Pagination]}
//                     className="max-w-[90%] lg:max-w-[80%]"
//                 >
//                     {ServiceData.map((item) => (
//                         <SwiperSlide key={item.title}>
//                             <div className="flex flex-col gap-4 mb-20 group relative shadow-lg text-white rounded-xl px-6 py-8 h-[250px] w-[250px] lg:h-[400px] lg:w-[400px]">
//                                 {/* Background Image */}
//                                 <div
//                                     className="absolute inset-0 bg-cover bg-center rounded-xl"
//                                     style={{ backgroundImage: `url(${item.backgroundImage})` }}
//                                 />
//                                 {/* Overlay */}
//                                 <div className="absolute inset-0 bg-purple-100 opacity-10 group-hover:opacity-30" />
//                                 {/* Icon and Content */}
//                                 <div className="relative flex flex-col gap-3">
//                                     {item.icon && (
//                                         <item.icon className="text-blue-600 group-hover:text-blue-400 w-[32px] h-[32px]" />
//                                     )}
//                                     <h3 className="text-lg font-semibold">{item.title}</h3>
//                                     <p className="text-sm">{item.description}</p>
//                                 </div>
//                                 {/* Arrow Icon */}
//                                 <RxArrowTopRight className="absolute rounded-xl bottom-5 left-5 w-[35px] h-[35px] text-white group-hover:text-blue-500 group-hover:rotate-45 duration-100" />
//                             </div>
//                         </SwiperSlide>
//                     ))}
//                 </Swiper>
//             </div>
//         </div>
//     );
// };

// export default Work;








// import React from 'react'
// import { Swiper, SwiperSlide } from 'swiper/react'
// import { FreeMode, Pagination, Autoplay } from 'swiper/modules'
// import { RxArrowTopRight } from 'react-icons/rx'
// import { ServiceData } from '../constants';


// // Import Swiper styles
// import 'swiper/css'
// import 'swiper/css/pagination'
// import 'swiper/css/free-mode'

// import {
//   RxCrop,
//   RxDesktop,
//   RxPencil2,
//   RxReader,
//   RxRocket,
//   RxAccessibility,
// } from "react-icons/rx"

// // Define the type for our service data
// // interface ServiceItem {
// //   icon: React.ElementType
// //   title: string
// //   content: string
// //   backgroundImage: string
// // }

// // // Our service data
// // export const ServiceData: ServiceItem[] = [
// //   {
// //     icon: RxCrop,
// //     title: "Development",
// //     content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
// //     backgroundImage: "/placeholder.svg?height=400&width=400",
// //   },
// //   {
// //     icon: RxPencil2,
// //     title: "Branding",
// //     content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
// //     backgroundImage: "/placeholder.svg?height=400&width=400",
// //   },
// //   {
// //     icon: RxDesktop,
// //     title: "Design",
// //     content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
// //     backgroundImage: "/placeholder.svg?height=400&width=400",
// //   },
// //   {
// //     icon: RxReader,
// //     title: "Seo",
// //     content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
// //     backgroundImage: "/placeholder.svg?height=400&width=400",
// //   },
// //   {
// //     icon: RxAccessibility,
// //     title: "Management",
// //     content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
// //     backgroundImage: "/placeholder.svg?height=400&width=400",
// //   },
// //   {
// //     icon: RxRocket,
// //     title: "Production",
// //     content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
// //     backgroundImage: "/placeholder.svg?height=400&width=400",
// //   },
// // ]

// const Work = () => {
//   return (
//     <div className="bg-gradient-to-b from-white to-purple-50 py-16">
//       <div className="container mx-auto px-4">
//         <div className="text-center mb-12">
//           <h1 className="font-extrabold text-3xl md:text-4xl text-purple-800 mb-4">
//             Our Work
//           </h1>
//           <p className="font-semibold text-lg md:text-xl text-blue-800">
//             We provide high standard solutions for your company's safety needs
//           </p>
//         </div>

//         <Swiper
//           breakpoints={{
//             340: {
//               slidesPerView: 1,
//               spaceBetween: 15,
//             },
//             640: {
//               slidesPerView: 2,
//               spaceBetween: 20,
//             },
//             1024: {
//               slidesPerView: 3,
//               spaceBetween: 30,
//             },
//           }}
//           freeMode={true}
//           pagination={{
//             clickable: true,
//           }}
//           autoplay={{
//             delay: 3000,
//             disableOnInteraction: false,
//           }}
//           modules={[FreeMode, Pagination, Autoplay]}
//           className="mySwiper"
//         >
//           {ServiceData.map((item, index) => (
//             <SwiperSlide key={index}>
//               <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-xl h-full flex flex-col">
//                 <div className="relative w-full h-64">
//                   <img
//                     src={item.backgroundImage}
//                     alt={item.title}
//                     layout="fill"
//                     objectFit="cover"
//                   />
//                   <div className="absolute inset-0 bg-black bg-opacity-10 flex p-5">
//                     <item.icon className="text-white w-10 h-10" />
//                   </div>
//                 </div>
//                 <div className="p-6 flex-grow flex flex-col justify-between">
//                   <div>
//                     <h3 className="text-xl font-semibold text-purple-800 mb-2">{item.title}</h3>
//                     {/* <p className="text-blue-600">{item.content}</p> */}
//                   </div>
//                   <div className="mt-4 flex justify-end">
//                     <RxArrowTopRight className="w-6 h-6 text-purple-600" />
//                   </div>
//                 </div>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </div>
//   )
// }

// export default Work










import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Autoplay } from "swiper/modules";
import { RxArrowTopRight } from "react-icons/rx";
import { ServiceData } from '../constants';

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";

// Import icons
// import {
//   RxCrop,
//   RxDesktop,
//   RxPencil2,
//   RxReader,
//   RxRocket,
//   RxAccessibility,
// } from "react-icons/rx";

// Service data
// const ServiceData = [
//   {
//     icon: RxCrop,
//     title: "Development",
//     content: "Custom software solutions tailored for your needs.",
//     backgroundImage: "/placeholder.svg?height=400&width=400",
//   },
//   {
//     icon: RxPencil2,
//     title: "Branding",
//     content: "Elevate your brand's identity with innovative ideas.",
//     backgroundImage: "/placeholder.svg?height=400&width=400",
//   },
//   {
//     icon: RxDesktop,
//     title: "Design",
//     content: "Exceptional designs that inspire and engage.",
//     backgroundImage: "/placeholder.svg?height=400&width=400",
//   },
//   {
//     icon: RxReader,
//     title: "SEO",
//     content: "Boost your website traffic with optimized solutions.",
//     backgroundImage: "/placeholder.svg?height=400&width=400",
//   },
//   {
//     icon: RxAccessibility,
//     title: "Management",
//     content: "Streamline operations with effective strategies.",
//     backgroundImage: "/placeholder.svg?height=400&width=400",
//   },
//   {
//     icon: RxRocket,
//     title: "Production",
//     content: "Seamless production processes for better results.",
//     backgroundImage: "/placeholder.svg?height=400&width=400",
//   },
// ];

const Work = () => {
  return (
    <div className="bg-gradient-to-b from-white to-purple-50 py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="font-extrabold text-3xl md:text-4xl text-purple-800 mb-4">
            Our Work
          </h1>
          <p className="font-semibold text-lg md:text-xl text-blue-800">
            We provide high-standard solutions for your company's safety needs
          </p>
        </div>

        <Swiper
          breakpoints={{
            340: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          freeMode={true}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[FreeMode, Pagination, Autoplay]}
          className="mySwiper"
        >
          {ServiceData.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl h-full flex flex-col">
                {/* Background image */}
                <div className="relative w-full h-64">
                  <img
                    src={item.backgroundImage}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0  flex items-center justify-center">
                    <item.icon className="text-white w-12 h-12" />
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 flex-grow flex flex-col justify-between">
                  <div>
                    <h3 className="text-xl font-semibold text-purple-800 mb-2">
                      {item.title}
                    </h3>
                    {/* <p className="text-blue-600">{item.content}</p> */}
                  </div>
                  <div className="mt-4 flex justify-end">
                    <RxArrowTopRight className="w-6 h-6 text-purple-600" />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Work;




